module.exports = __webpack_public_path__ + "supplier/img/placeholder.82d6df19.png";